import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="summary-table-card"
// Mobile accordion (dropdown) por broker de la tabla resumen `mejores`
// (TC-133-1.3.2.2). Cada `<tr.summary-table__row>` es una card colapsable: el
// header (logo + nombre + frase + nota) y el CTA "Visitar" (ronda 19) siempre se
// ven; el cuerpo (comisiones, regulación, producto) se despliega al pulsar el
// chevron.
//
// Solo gobierna el estado abierto/cerrado: el layout y la visibilidad de las
// celdas los resuelve la hoja de estilos según la clase `--open`, dentro del
// bloque `respond-until(m)`. En Desktop el botón está oculto por CSS, así que
// este controller no tiene efecto visible aunque esté montado.
export default class extends Controller {
  // El `toggle` se dispara desde varios sitios de la franja del header (ronda 07
  // item 4): el chevron `.summary-table__toggle`, el `th` del broker
  // (logo + nombre + frase) y la celda de la nota (`puntuacion`). Para que toda la
  // franja sea clicable se cuelga la acción en esas celdas además del chevron.
  //
  // Dos guardas evitan efectos no deseados:
  //   1. Clicks en controles interactivos (enlaces "Ver más"/"Visitar", botón ⓘ de
  //      criterios) NO deben plegar/desplegar la card: se ignoran.
  //   2. El chevron lleva su propia acción `summary-table-card#toggle`; al pulsarlo
  //      el evento también burbujea hasta la celda padre, que tiene la misma acción
  //      → se ejecutaría dos veces (toggle doble = sin efecto). Se ignora el handler
  //      de celda cuando el origen está dentro del chevron, dejando que sólo dispare
  //      la acción del propio botón (que además porta `aria-expanded`).
  //
  // Ronda 18: la nota, el ⓘ y el chevron viven dentro del `th` del broker, y el
  // botón «Ver desglose» abre un `<dialog>` dentro de la card; tampoco pliegan.
  toggle(event) {
    if (event?.target.closest('a, button.summary-table__score-info, .summary-table__breakdown')) return
    const desdeChevron = event?.target.closest('button.summary-table__toggle')
    const enChevron = event?.currentTarget?.classList.contains('summary-table__toggle')
    if (desdeChevron && !enChevron) return

    const abierta = this.element.classList.toggle('summary-table__row--open')
    const boton = this.element.querySelector('.summary-table__toggle')
    if (boton) {
      boton.setAttribute('aria-expanded', abierta ? 'true' : 'false')
    }
  }
}
